import './styles.sass';

import React from 'react';

const TopItemList = ({ children }) => <ol className="TopItemList">{children}</ol>;
const TopItemListItem = ({ children, ...rest }) => (
  <li className="TopItemList-item" {...rest}>
    {children}
  </li>
);

TopItemList.Item = TopItemListItem;

export default TopItemList;
